import { Gender } from './Gender';
import { DeliveryAddress } from './DeliveryAddress';

export class Customers {
    public id: string;
    public customerName: string;
    public customerImage: string;
    public address: string;
    public emailId: string;
    public mobileNumber: string;
    public password: string;
    public genderObj: Gender;
    public defaultDeliveryAddress: DeliveryAddress;
    public isActive: Boolean;
    public isNew: Boolean;
    public provider: string;
    public providerId: string;
    public authToken: string;
}
